import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { Environment } from 'dashboard/models/environment';
import { Webhook } from 'dashboard/models/webhook';
import { setWebhooks } from 'dashboard/redux/slices/webhooks';
import { ApiEndpoint, PaginationParams } from 'lib/interfaces/api';

export function loadWebhookList({
  currentEnvironment,
  abortSignal,
}: {
  currentEnvironment?: Environment;
  abortSignal?: AbortSignal;
}) {
  return async (dispatch: Dispatch) => {
    const webhooksResponse = await SessionClientDashboard.listResource<Webhook, PaginationParams>(
      ApiEndpoint.Webhook,
      { filter: { 'environment-id': currentEnvironment?.id }, signal: abortSignal },
    );

    const webhooks = webhooksResponse.data;
    dispatch(setWebhooks(webhooks));
  };
}
